import * as types from '../actions/volume3Ds';
import { apiFetch } from '../../utils/requests';
import { updateVolume3DURL } from '../../settings/api';

/**
 * action creator for updateVolume3DAction
 * @param  {Object} volume3D - volume3D object returned from API
 * @return {Object} - action object
 */
export function updateVolume3DAction(volume3D) {
  return {
    type: types.UPDATE_VOLUME_3D,
    payload: { volume3D },
  };
}

/**
 * updates specified volume3D through PATCH
 * @param  {number} volume3DID - ID of volume3D to update
 * @return {function} - thunk for updateVolume3D
 */
export default function updateVolume3D(volume3DID, data) {
  return (dispatch, getState) => {
    if (volume3DID == null) {
      return Promise.reject(new Error('volume3DID must be defined'));
    }

    const volume3DUrl = updateVolume3DURL(volume3DID);

    // PATCH volume3D
    return apiFetch(volume3DUrl, getState().auth.get('token'), 'PATCH', data).then(volume3D => {
      dispatch(updateVolume3DAction(volume3D));
      return volume3D;
    });
  };
}
